module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/logo-aoj-vi-157cfe9dfc5e77678cc4ecfdee3afc0f.svg";